import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88f7df30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "privacy-level-indicator" }

import { computed } from 'vue'
import { PrivacyLevel } from '@/gp/GroupAdminModel'
import { GlobeIcon, UsersIcon, SmileIcon, LockIcon } from '@zhuowenli/vue-feather-icons'


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyLevelIndicator',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;



const displayText = computed(() => props.value)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.value == _unref(PrivacyLevel).Everyone)
      ? (_openBlock(), _createBlock(_unref(GlobeIcon), { key: 0 }))
      : (props.value == _unref(PrivacyLevel).Groups)
        ? (_openBlock(), _createBlock(_unref(UsersIcon), { key: 1 }))
        : (props.value == _unref(PrivacyLevel).Friends)
          ? (_openBlock(), _createBlock(_unref(SmileIcon), { key: 2 }))
          : (props.value == _unref(PrivacyLevel).Me)
            ? (_openBlock(), _createBlock(_unref(LockIcon), { key: 3 }))
            : _createCommentVNode("", true)
  ]))
}
}

})